import { render, staticRenderFns } from "./AppUsageChart.vue?vue&type=template&id=0a827194&scoped=true&"
import script from "./AppUsageChart.vue?vue&type=script&lang=js&"
export * from "./AppUsageChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a827194",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VDivider})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Cam\\projects\\netcountable-app\\truple\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a827194')) {
      api.createRecord('0a827194', component.options)
    } else {
      api.reload('0a827194', component.options)
    }
    module.hot.accept("./AppUsageChart.vue?vue&type=template&id=0a827194&scoped=true&", function () {
      api.rerender('0a827194', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Charts/AppUsageChart.vue"
export default component.exports